import React from "react";
import { motion } from "framer-motion";
import product1 from '../../images/Product/SR07.png';
import product2 from '../../images/Product/SR12.png';
import product3 from '../../images/Product/SR31.png';
import product4 from '../../images/Product/SR21.png';

// Dummy products array; replace with actual products data as needed
const products = [
  {
    img: product1,
    title: "ETS Rose Product 1",
    description: "Elegant design with premium quality.",
    specifications: [
      "Material: High-quality rosewood",
      "Dimensions: 10x10x10 cm",
      "Weight: 500g",
      "Color: Natural wood finish"
    ]
  },
  {
    img: product2,
    title: "ETS Rose Product 2",
    description: "Crafted with precision for ultimate performance.",
    specifications: [
      "Material: Stainless steel",
      "Dimensions: 15x15x15 cm",
      "Weight: 1kg",
      "Color: Silver"
    ]
  },
  {
    img: product3,
    title: "ETS Rose Product 3",
    description: "Innovative style meets modern functionality.",
    specifications: [
      "Material: Carbon fiber",
      "Dimensions: 20x20x20 cm",
      "Weight: 750g",
      "Color: Black"
    ]
  },
  {
    img: product4,
    title: "ETS Rose Product 4",
    description: "Timeless classic with a touch of luxury.",
    specifications: [
      "Material: Gold-plated",
      "Dimensions: 25x25x25 cm",
      "Weight: 1.5kg",
      "Color: Gold"
    ]
  }
];

const CardComponent = () => {
  return (
    <section className="bg-white py-12">
      <h1 className="xl:text-5xl md:text-4xl text-2xl font-semibold leading-tight text-center text-gray-800 sm:mb-0 mb-12">
        Nos Produits
          </h1>
          <br/>
      
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((product, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="rounded-lg shadow-lg dark:bg-gray-500 transition transform hover:-translate-y-2 hover:scale-105 hover:shadow-xl duration-300"
            >
              <img
                src={product.img}
                alt={`product ${index + 1}`}
                className="w-full object-cover rounded-t-lg"
              />
              {/* <div className="p-4">
                <h2 className="text-xl font-semibold text-gray-900">{product.title}</h2>
                <p className="mt-2 text-base text-gray-700">{product.description}</p>
              </div> */}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CardComponent;
